import { t } from '@lingui/macro'
import {
  ExportEventInviteesQuery,
  RecurringExportEventInviteesQuery
} from './AttendanceTab.codegen'

export const prepareCSVRecurringEventAttendExport = (
  data: NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<RecurringExportEventInviteesQuery>['admin']
        >['recurringEvent']
      >['exportInviteesIncludingIndirect']
    >['items']
  >
) =>
  data.map((row) => {
    const user = row.user!
    return {
      [t`Series ID`]: row.series_id,
      [t`Attendance type`]: row.attendance_type,
      [t`Number of occurrences`]: row.number_of_occurences,
      [t`Created by`]: row.created_by,
      [t`Event ID`]: row.event_id,
      [t`Event title`]: row.event_title,
      [t`Start time`]: row.start_time,
      [t`End time`]: row.end_time,
      [t`Facilitator`]: row.facilitator,
      [t`Email`]: user.email,
      [t`Display name`]: user.display_name,
      [t`First name`]: user.first_name,
      [t`Last name`]: user.last_name,
      [t`Organisation role`]: user.organisation_role,
      [t`RSVP`]: row.rsvp,
      [t`Attendance`]: row.attendance,
      [t`Created at`]: row.created_at
    }
  })

export const prepareCSVEventAttendExport = (
  data: NonNullable<
    NonNullable<
      NonNullable<ExportEventInviteesQuery['admin']>['event']
    >['inviteesIncludingIndirect']
  >['items']
) =>
  data.map((row) => ({
    [t`Email`]: row.user.email,
    [t`Display name`]: row.user.display_name,
    [t`First name`]: row.user.first_name,
    [t`Last name`]: row.user.last_name,
    [t`Organisation role`]: row.user.organisation_role,
    [t`Attendance`]: row.attending,
    [t`Present`]: row.present,
    [t`Created at`]: row.created_at
  }))
